import { AcessoResulthLocalConnectStruct } from "../../structs/interface-resulth-local-connect/acesso-resulth-local-connect.struct";

export class AcessoResulthLocalConnectRequest {
  acessoResulthLocalConnect: AcessoResulthLocalConnectStruct
  matriz?: boolean | null;
}